export default "__VITE_ASSET__C5d8xOOR__"